/**
 * Module itxApp.common
 */

/* jshint ignore:start */
(function(itxApp) {

    'use strict';

    
    /* 
    ** No se si son necesarios,
    ** 'ngAnimate', 'ngMessages', 'angular-click-outside',
    **/

    angular.module('itxApp.common', [
            'ngMessages'
        ]).run(Run)
        .config(XConfig)
        .config(CompileProvider)
        .config(defineSpecialClasses);

    //Run config
    Run.$inject = ['$rootScope'];

    function Run($rootScope) {
        //Polyfill. Necesary for the ItxMatchMediaSvc & ItxMatchMediaFlt to work properly
        initializeMatchMedia();
        // wrapInditexText();
        //Hack!! => Make inditex available in views though the $root angular private property
        $rootScope.inditex = inditex;

        inditex.xconf = {};
        _.each(inditex.iXconfVars, function(conf) {

            inditex.getXconfiguracionValue(conf, function(status, value) {

                inditex.xconf[conf] = value;

            });
        });

        window.state = {};
     
    }

    /**
     * matchMedia() polyfill - Test a CSS media type/query in JS.
     * Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight.
     * Dual MIT/BSD license
     */
    function initializeMatchMedia() {
        window.matchMedia || (window.matchMedia = function matchMediaPolyfill() {

            // For browsers that support matchMedium api such as IE 9 and webkit
            var styleMedia = (window.styleMedia || window.media);

            // For those that don't support matchMedium
            if (!styleMedia) {
                var style = document.createElement('style'),
                    script = document.getElementsByTagName('script')[0],
                    info = null;

                style.type = 'text/css';
                style.id = 'matchmediajs-test';

                script.parentNode.insertBefore(style, script);

                // 'style.currentStyle' is used by IE <= 8
                // 'window.getComputedStyle' for all other browsers
                info = ('getComputedStyle' in window) && window.getComputedStyle(style, null) || style.currentStyle;

                styleMedia = {
                    matchMedium: function(media) {
                        var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';

                        // 'style.styleSheet' is used by IE <= 8
                        // 'style.textContent' for all other browsers
                        if (style.styleSheet) {
                            style.styleSheet.cssText = text;
                        } else {
                            style.textContent = text;
                        }

                        // Test if media query is true or false
                        return info.width === '1px';
                    }
                };
            }

            return function(media) {
                return {
                    matches: styleMedia.matchMedium(media || 'all'),
                    media: media || 'all'
                };
            };
        }());
    }

    //Config XConfiguration variables
    function XConfig($sceDelegateProvider) {
        if (!inditex.iXconfVars) {
            inditex.iXconfVars = [];
        }
        var configurations = [
            'COLBENSON_SEARCHBROKER_ENABLED',
            'COLBENSON_SEARCHBROKER_URL_API',
            'COLBENSON_SEARCHBROKER_URL_JS',
            'ENABLE_FILTER_STOCK_COLBENSON',
            'BAIDU_MAPS_KEY',
            'SHOW_LOCAL_STORE',
            'SEASONS_STOCK_QUERY_ALLOWED',
            'REGEXP_PHONE_VALIDATION',
            'HIDE_YEAR_AND_GENDER_ENABLED',
            'ENABLED_SMS_PASSWORD_RESET',
            'GOOGLE_MAPS_REQUEST',
            'GOOGLE_MAPS_LIBRARY',
            'FULL_ADDRESS_MASK',
            'ANALYTICS_SEARCHENGINE_ENABLED',
            'PHONE_REGISTER_LOGIN_ENABLED',
            'ATTR_TAILORING_SHOWED',
            'RADIUS_SEARCH_STORE',
            'MIN_STORE_SEARCH_STORE',
            'DROP_POINT_SERVICE_PROVIDER',
            'DROPPOINT_ENABLED_FRONT',
            'XMEDIA_CLASS',
            'MAPS_MIN_ZOOM',
            'MAPS_ZOOM_ICONS_CHANGE',
            'STORELOCATOR_MAX_STORE_COUNT',
            'ENABLE_GUEST_TRACKING_BY_SMS',
            'DIMENSIONES_CAPTCHA',
            'SHOW_SPECIAL_MSPOT_FAMILIES',
            'DELIVERY_TIME_STORE',
            'NEWSLETTER_DOUBLE_OPT_IN',
            'WIDE_EYES_ENABLED',
           
            'PRODUCT_DIMESIONS',
            'FORMAT_MULTIBANCO_AMOUNT',
            'ADD_TO_CART_POPUP_ENABLED',
            'SEO_PRODUCT_REDIRECT',
            'SEO_CATEGORY_REDIRECT',
            'TIME_RELOAD_AJAX_REQUEST',
            'ENABLED_SOLD_OUT_410_PAGE',
            'SHOW_PRODUCT_CATEGORY_SKU_NO_STOCK',
            'TAG_MANAGER_CODE_RESPONSIVE',
            'FACEBOOK_APP_ID',
            'ENABLED_NEWSLETTER_BOYS_AND_GIRLS',
            'ENABLED_NEWSLETTER_TAILORING',
            'ENABLE_XNOTIFICACION_STOCK_SUBSCRIBER',
            'ENABLE_PHONE_VALIDATION',
            'MIN_ORDER_PRICE_FISCALID',
            'MIN_ORDER_PRICE_TO_INVOICE',
            'ENABLE_PEC_AND_RECEIVER_CODE',
            'ENABLE_GEOBLOQUEO',
            'WEB_WW_COUNTRY_ISOS',
            'ENABLED_UNBOUND_PAYMENTS',
            'ENABLED_SPONSORSHIP_PROMOTIONS'
        ];

        if (inditex.iXconfVars.length === 0) {
            inditex.iXconfVars = configurations;
        } else {
            inditex.iXconfVars.concat(configurations);
        }

        $sceDelegateProvider.resourceUrlWhitelist([
            // Allow same origin resource loads.
            'self',
            // Allow loading from our assets domain. **.
            'https://player.vimeo.com/**'
        ]);

    }

    function defineSpecialClasses() {
        if (String(navigator.userAgent).toLowerCase().indexOf('massimodutti_ecom') > -1) {
            $('body').addClass('webapp');
        }
        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/FBAV/i)) {
            $('body').addClass('facebook_webview');
        }
        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/Instagram/i)) {
            $('body').addClass('instagram_webview');
        }
        if (navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i) ) 
        {
            $('html').addClass('is-mobile');
        } else{
            $('html').addClass('is-desktop');
        }
    }

    //Add whatsapp to the list of allowed protocols
    CompileProvider.$inject = ['$compileProvider'];

    function CompileProvider($compileProvider) {
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|whatsapp|tel|massimodutti):/);
    }

    /** Public */
    itxApp.common = {};
    itxApp.common.Run = Run;
    itxApp.common.XConfig = XConfig;
    //itxApp.common.HammerConfig = HammerConfig;

})(window.itxApp);